import type { i18n as I18n } from "i18next";
import en from "@/locales/en/puzzle-types/hidden_article.json";
import fr from "@/locales/fr/puzzle-types/hidden_article.json";

export const HIDDEN_ARTICLE_NS = "puzzle-types/hidden_article";

/** Adds this type's translations to an initialised i18next instance (idempotent). */
export function registerHiddenArticleTranslations(i18n: I18n): void {
  if (!i18n.hasResourceBundle("en", HIDDEN_ARTICLE_NS))
    i18n.addResourceBundle("en", HIDDEN_ARTICLE_NS, en, true, true);
  if (!i18n.hasResourceBundle("fr", HIDDEN_ARTICLE_NS))
    i18n.addResourceBundle("fr", HIDDEN_ARTICLE_NS, fr, true, true);
}
